import useSiteTranslation from '@/providers/i18n/hooks/useSiteTranslation';
import { PAGE_TEXTS_KEYS, emailFormatRegex } from '../../../../../../../constants/constant';
import { Button } from '../../../../ui/button';
import { CardContent } from '../../../../ui/card';
import InputField from '../../../../ui/customInput/input';
const Index = ({ FORM_FIELD_SPECS, selectedSearchType, searchParams, errors, register, setValue }: any) => {
  const Texts = useSiteTranslation(PAGE_TEXTS_KEYS?.customerAndOrderSearch);
  return (
    <CardContent className="space-y-2 lg:pr-0" key={`key_${selectedSearchType}`}>
      <div className="flex">
        <InputField
          items={`${Texts?.emailAddress}`}
          id={FORM_FIELD_SPECS?.emailAddress?.id}
          htmlFor={FORM_FIELD_SPECS?.emailAddress?.id}
          register={register}
          errors={errors}
          label={Texts?.emailAddress}
          classname="w-full"
          rules={{
            required: Texts?.emailAddressRequired,
            pattern: {
              value: emailFormatRegex,
              message: Texts?.emailInvalidFormat,
            },
          }}
          defaultValue={searchParams?.[FORM_FIELD_SPECS?.emailAddress?.id]}
          maxLength={FORM_FIELD_SPECS?.emailAddress?.maxLength}
          hideError
          setValue={setValue}
        />
        <Button className="ml-5 h-auto bg-[#002C4E] px-8 text-18 text-white" type="submit">
          <span className="text-lg font-semibold text-white">{Texts?.searchButtonText}</span>
        </Button>
      </div>
      {errors?.[FORM_FIELD_SPECS?.emailAddress?.id] && (
        <p className="mt-2 text-sm text-scarletRed">{errors[FORM_FIELD_SPECS?.emailAddress?.id]?.message}</p>
      )}
    </CardContent>
  );
};

export default Index;
